import * as Const from '../constants/index';
import State from '../interfaces/state/HelpState';

const initState: State = {
  email: '',
  isLoading: false,
  isError: false,
  isEmailSuccesfullySend: false,
};

export default function help(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.HELP_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.HELP_FIELD_VALUE:
      return {
        ...state,
        email: action.payload,
      };

    case Const.HELP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isEmailSuccesfullySend: true,
      };

    case Const.HELP_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.HELP_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    default:
      return state;
  }
}
